<template>
  <div class="container mt-5 pt-1 home">
    <!--          <Loading v-if="data_block==null"/>-->
    <div>
      <!--            <div v-else>-->
      <!-- search -->
      <div class="mb-none ">
<!--        <div class="search-title">MAP Testnet</div>-->
        <div class="search-title">{{showMainnt}}</div>
        <headerSearch class="bg-card mt-4" style="height: 50px;"/>
      </div>

      <!-- chart -->
      <div class="mt-4 pt-2">
        <div class="home-chart">

          <!--                      echarts-->
          <div class="bg-card mr-2 mb-3" style="flex: 1;height: 255px">
            <div class="px-4">
              <div class="mt-4 mb-2 trans-title">
                {{showMainnt}} 14 day Transaction History
              </div>
              <div>
                <Chart_line_two v-if="chainList.charData" :xaxis="chartX" :yaxis="chartY"/>
              </div>
            </div>
          </div>

          <!--                      第二个卡片-->
          <div class="bg-card mx-3 mb-3" style="flex: 1;height: 255px">
            <div class="p-4">
              <div class="trans-title">
                Chain Details
              </div>
              <div class="trans-detail">
                <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                  <div class="trans-icon">
                    <img src="../../images/transtion/icon1.png"/>
                  </div>
                  <div class="trans-icon-title ml-2">
                    <span>TOTAL BLOCKS</span>
                    <span>{{ parseFloat(chainList.totalBlocks) }}</span>
                  </div>
                </div>
                <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                  <div class="trans-icon">
                    <img src="../../images/transtion/icon2.png"/>
                  </div>
                  <div class="trans-icon-title ml-2 ">
                    <span>BLOCK TIME</span>
                    <span>~{{ parseFloat(chainList.blockTime) }} SECS</span>
                  </div>
                </div>
              </div>
              <div class="trans-detail">
                <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                  <div class="trans-icon">
                    <img src="../../images/transtion/icon3.png"/>
                  </div>
                  <div class="trans-icon-title ml-2">
                    <span>TOTAL TXS</span>
                    <span>{{ parseFloat(chainList.totalTxs) }}</span>
                  </div>
                </div>
                <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                  <div class="trans-icon">
                    <img src="../../images/transtion/icon4.png"/>
                  </div>
                  <div class="trans-icon-title ml-2 ">
                    <span>TOTAL ADDRESSES</span>
                    <span>{{ parseFloat(chainList.totalAddress)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!--                      第三个卡片-->
          <div class="bg-card mx-2 mb-3" style="flex: 1;height: 255px">
            <div class="p-4">
              <div class=" trans-title">
                Cross-Chain Details
              </div>
              <div>
                <div class="trans-detail">
                  <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                    <div class="trans-icon">
                      <img src="../../images/transtion/icon5.png"/>
                    </div>
                    <div class="trans-icon-title ml-2">
                      <span>TOTAL TXs</span>
                      <span>0</span>
                    </div>
                  </div>
                  <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                    <div class="trans-icon">
                      <img src="../../images/transtion/icon5.png"/>
                    </div>
                    <div class="trans-icon-title ml-2">
                      <span>7 DAYs TXs</span>
                      <span>0</span>
                    </div>
                  </div>
                </div>
<!--                <div class="trans-line"></div>-->
                <div class="trans-detail">
                  <div style="padding-top: 0;flex: 1" class="trans-detail">
                    <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                      <div class="trans-icon">
                        <img src="../../images/transtion/icon6.png"/>
                      </div>
                      <div class="trans-icon-title ml-2">
                        <span>TOTAL VOLUME</span>
                        <span>$0</span>
                      </div>
                    </div>
                  </div>
                  <div style="flex: 1" class="d-flex flex-row align-items-lg-center">
                    <div class="trans-icon">
                      <img src="../../images/transtion/icon6.png"/>
                    </div>
                    <div class="trans-icon-title ml-2">
                      <span>7 DAYs VOLUME</span>
                      <span>$0</span>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

      <div class="home-latest">
        <!--               Latest Block-->
        <div class="mt-5 d-flex flex-column align-items-start latest-block">
          <div class="latest">
            <span>Latest Blocks</span>
            <button @click="goBlock()">View all</button>
          </div>

          <div class="bg-card mt-4 pt-2 w-100">
            <TableBlock :data="data_block"/>
          </div>

        </div>
        <!--                Latest Transactions-->
        <div class="mt-5 d-flex flex-column align-items-start latest-block">
          <div class="latest">
            <span>Latest Transactions</span>
            <button @click="goTransaction()">View all</button>
          </div>

          <div class="bg-card mt-4 pt-2 w-100">
            <TableTransactions key="Select" :data="data_trans"/>
          </div>
        </div>
      </div>


    </div>
<!--  </div>-->

</template>

<script>
import headerSearch from '@/views/_frame/header_search.vue'
import Chart_line_two from "@/views/_comp/chart_line_two";
import TableBlock from "@/views/_comp_busi/table_last_block";
import TableTransactions from "@/views/_comp_busi/table_last_transactions";
import Decimal from 'decimal.js'

export default {
  name: 'pageHome',
  components: {
    TableTransactions,
    TableBlock,
    headerSearch,
    Chart_line_two,
  },
  props: [],
  data() {
    return {
      showMainnt:'MAPO Mainnet',//判断测试网名字
      chartX: [],//chartX数据
      chartY: [],//chartY数据
      chainList: {},//chain detail表数据
      data_block: null,//模拟block数据
      data_trans: [],//trans数据
      ct: null,
      timer:null,
      chainDetail:{},
    }
  },
  computed: {},
  watch: {	//监听，监听什么？我们在data中定义一个变量，就监听这个变量
    chainList() {		//被监听的变量，也可以是对象集合等
      //当today中的值变化时，我们就触发定时事件
      // this.times()
    }
  },
  methods: {

    //跳转block
    goBlock() {
      this.$router.push(
          {
            path: "/block",
          }
      )
    },

    //跳转transaction
    goTransaction() {
      this.$router.push(
          {
            path: "/transaction",
          }
      )
    },

    referData() {
      let v = this

      v.api('home', {}, {
        vue: v,
        key_data: 'data',
      }).then(function (res) {
        if (res.code == 200) {
          v.chainList = res.data
          v.data_block = res.data.blocksList
          v.data_trans = res.data.transactionList
          //详情
          v.chainDetail.txCrossCount= res.data.txCrossCount

          if (new Decimal(res.data.allCrossCount).comparedTo(new Decimal(10).pow(9))>0) {
            v.chainDetail.allCrossCount=new Decimal(res.data.allCrossCount).div(new Decimal(10).pow(6)).toFixed(2)+' M'
          }else if(new Decimal(res.data.allCrossCount).comparedTo(new Decimal(10).pow(6))>0){
            v.chainDetail.allCrossCount=new Decimal(res.data.allCrossCount).div(new Decimal(10).pow(3)).toFixed(2)+' K'
          }else{
            v.chainDetail.allCrossCount= res.data.allCrossCount.toFixed(2)
          }
          v.chainDetail.dayTxCrossCount= res.data.dayTxCrossCount

          if (new Decimal(res.data.dayAllCrossCount).comparedTo(new Decimal(10).pow(9))>0) {
            v.chainDetail.dayAllCrossCount=new Decimal(res.data.dayAllCrossCount).div(new Decimal(10).pow(6)).toFixed(2)+' M'
          }else if(new Decimal(res.data.dayAllCrossCount).comparedTo(new Decimal(10).pow(6))>0){
            v.chainDetail.dayAllCrossCount=new Decimal(res.data.dayAllCrossCount).div(new Decimal(10).pow(3)).toFixed(2)+' K'
          }else{
            v.chainDetail.dayAllCrossCount= res.data.dayAllCrossCount.toFixed(2)
          }
          res.data.charData.forEach((k, val) => {
            // console.log(val)
            for (var i in k) {
              v.chartY.push(i);
              v.chartX.push(k[i]);
            }
          })
        }
      })
    },

    //获取数据
    getData() {
      let v = this

      v.api('home', {}, {
        vue: v,
        key_data: 'data',
      }).then(function (res) {
        // console.log('Homedata', res)
        if (res.code == 200) {
          v.chainList = res.data
          v.data_block = res.data.blocksList
          v.data_trans = res.data.transactionList

          //详情
          v.chainDetail.txCrossCount= res.data.txCrossCount

          if (new Decimal(res.data.allCrossCount).comparedTo(new Decimal(10).pow(9))>0) {
            v.chainDetail.allCrossCount=new Decimal(res.data.allCrossCount).div(new Decimal(10).pow(6)).toFixed(2)+' M'
          }else if(new Decimal(res.data.allCrossCount).comparedTo(new Decimal(10).pow(6))>0){
            v.chainDetail.allCrossCount=new Decimal(res.data.allCrossCount).div(new Decimal(10).pow(3)).toFixed(2)+' K'
          }else{
            v.chainDetail.allCrossCount= res.data.allCrossCount.toFixed(2)
          }
          v.chainDetail.dayTxCrossCount= res.data.dayTxCrossCount

          if (new Decimal(res.data.dayAllCrossCount).comparedTo(new Decimal(10).pow(9))>0) {
            v.chainDetail.dayAllCrossCount=new Decimal(res.data.dayAllCrossCount).div(new Decimal(10).pow(6)).toFixed(2)+' M'
          }else if(new Decimal(res.data.dayAllCrossCount).comparedTo(new Decimal(10).pow(6))>0){
            v.chainDetail.dayAllCrossCount=new Decimal(res.data.dayAllCrossCount).div(new Decimal(10).pow(3)).toFixed(2)+' K'
          }else{
            v.chainDetail.dayAllCrossCount= res.data.dayAllCrossCount.toFixed(2)
          }

          //chart数据
          res.data.charData.forEach((k, val) => {
            // console.log(val)
            for (var i in k) {
              v.chartY.push(i);
              v.chartX.push(k[i]);
            }
          })
          // console.log('chart', v.chartY, v.chartX)
        }
      })
    },

    times() {
      this.timer =setInterval( this.referData,6000);

    },
  },
  created() {
    this.getData()
  },
  beforeDestroy() {

    if (this.timer){
      clearInterval(this.timer);
      this.timer=null;
    }
  },
  destroyed(){
    // console.log("Home destroyed")
  },
  mounted() {
    if (document.location.href=='https://maposcan.io/'){
      this.showMainnt = 'MAPO Mainnet'
    }
    else if(document.location.href=='https://testnet.maposcan.io/') {
      this.showMainnt = 'MAPO Testnet'
    }

    // console.log("Home mounted")
  },

  activated() {
    if (this.timer==null){
      this.times();
    }
  },
  deactivated() {
    // console.log("Home deactivated")
    if (this.timer){
      clearInterval(this.timer);
      this.timer=null;
    }
  }

  // beforeDestroy() {
  //   this.ct && clearTimeout(this.ct);
  // }
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>

.home {
  padding-bottom: 134px;
}

.search-title {
  text-align: left;
  width: 100%;
  font-family: 'poppinBold';
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.latest {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span {
    font-family: 'poppinBold';
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  button {
    outline-style: none;
    border: 0;
    width: 90px;
    height: 30px;
    border-radius: 8px;
    background-color: #3772ff;
    color: white;
    font-family: 'poppinBold';
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }
}

.home-latest {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.latest-block {
  width: 48%;
}

.home-chart {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}


@media (max-width: 1200px) {
  .home-latest {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .latest-block {
    width: 100%;
  }
}

</style>
